import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, uniqBy } from 'lodash-es';

// Components
import { ColorSwatch } from 'site-modules/shared/components/color-swatch/color-swatch';

import './car-color-section.scss';

export function CarColorSection({ colors = null, type = 'interior', idPrefix = '', isSmall = false }) {
  return isEmpty(colors) ? (
    <span className="text-gray-darker">Not Available</span>
  ) : (
    <div className="car-color-section text-gray-darker mt-0_75 mt-md-0">
      {uniqBy(colors, 'title').map(({ title, color }, index) => (
        <div
          className="d-inline-block mb-0_75 me-0_75 pos-r"
          key={`${idPrefix}_${type}_${title}`}
          style={{ minHeight: isSmall ? '20px' : '26px' }}
        >
          <ColorSwatch
            id={`${idPrefix}${type}_tooltip${index}`}
            color={color}
            title={title}
            displayTooltip
            displayColorName={false}
          />
        </div>
      ))}
    </div>
  );
}

CarColorSection.propTypes = {
  colors: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      color: PropTypes.shape({
        r: PropTypes.number,
        g: PropTypes.number,
        b: PropTypes.number,
      }),
    })
  ),
  type: PropTypes.string,
  idPrefix: PropTypes.string,
  isSmall: PropTypes.bool,
};
